<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5>Produtos</h5>
      <b-button
        variant="success"
        @click="abrirModalImpressao"
        :disabled="loading"
      >
        <i class="fas fa-print"></i> Imprimir Cardápio
      </b-button>
    </div>

    <!-- Modal para escolher tema do cardápio -->
    <b-modal
      id="modal-impressao-cardapio"
      title="Escolha o Tema do Cardápio"
      size="lg"
      @ok="imprimirCardapioComTema"
      ok-title="Imprimir"
      cancel-title="Cancelar"
    >
      <div class="row">
        <div class="col-md-3">
          <div 
            class="tema-preview tema-limpo"
            :class="{ 'tema-selecionado': temaSelecionado === 'limpo' }"
            @click="temaSelecionado = 'limpo'"
          >
            <div class="preview-header">
              <h3>Tema Limpo</h3>
              <p>Versão tradicional, ideal para impressão</p>
            </div>
            <div class="preview-content">
              <div class="preview-categoria">
                <h4>Pizzas</h4>
                <div class="preview-item">
                  <span>Pizza Margherita</span>
                  <span>R$ 25,90</span>
                </div>
                <div class="preview-item">
                  <span>Pizza Calabresa</span>
                  <span>R$ 28,90</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-3">
          <div 
            class="tema-preview tema-estilizado"
            :class="{ 'tema-selecionado': temaSelecionado === 'estilizado' }"
            @click="temaSelecionado = 'estilizado'"
          >
            <div class="preview-header">
              <h3>Tema Escuro</h3>
              <p>Versão moderna com fundo escuro</p>
            </div>
            <div class="preview-content">
              <div class="preview-categoria">
                <h4>🍕 Pizzas</h4>
                <div class="preview-item">
                  <span>Pizza Margherita</span>
                  <span class="preco-destaque">R$ 25,90</span>
                </div>
                <div class="preview-item">
                  <span>Pizza Calabresa</span>
                  <span class="preco-destaque">R$ 28,90</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div 
            class="tema-preview tema-estilizado-claro"
            :class="{ 'tema-selecionado': temaSelecionado === 'estilizado-claro' }"
            @click="temaSelecionado = 'estilizado-claro'"
          >
            <div class="preview-header">
              <h3>Tema Claro</h3>
              <p>Versão moderna com fundo branco</p>
            </div>
            <div class="preview-content">
              <div class="preview-categoria">
                <h4>🍕 Pizzas</h4>
                <div class="preview-item">
                  <span>Pizza Margherita</span>
                  <span class="preco-destaque-claro">R$ 25,90</span>
                </div>
                <div class="preview-item">
                  <span>Pizza Calabresa</span>
                  <span class="preco-destaque-claro">R$ 28,90</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div 
            class="tema-preview tema-estilizado-branco"
            :class="{ 'tema-selecionado': temaSelecionado === 'estilizado-branco' }"
            @click="temaSelecionado = 'estilizado-branco'"
          >
            <div class="preview-header">
              <h3>Tema Branco</h3>
              <p>Versão minimalista e elegante</p>
            </div>
            <div class="preview-content">
              <div class="preview-categoria">
                <h4>🍕 Pizzas</h4>
                <div class="preview-item">
                  <span>Pizza Margherita</span>
                  <span class="preco-destaque-branco">R$ 25,90</span>
                </div>
                <div class="preview-item">
                  <span>Pizza Calabresa</span>
                  <span class="preco-destaque-branco">R$ 28,90</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal para visualizar e trocar imagem do produto -->
    <b-modal
      id="modal-imagem-produto"
      :title="`Imagem - ${produtoSelecionado ? produtoSelecionado.nome : ''}`"
      size="lg"
      @ok="salvarImagem"
      @cancel="cancelarEdicaoImagem"
      ok-title="Salvar"
      cancel-title="Cancelar"
    >
      <div class="text-center mb-3">
        <!-- Visualização da imagem atual -->
        <div v-if="produtoSelecionado && produtoSelecionado.imagens && produtoSelecionado.imagens.length > 0" class="current-image-container">
          <img 
            :src="produtoSelecionado.imagens[0].fileURL" 
            :alt="produtoSelecionado.nome"
            class="current-image"
          />
        </div>
        <div v-else class="no-image-placeholder">
          <i class="fas fa-image"></i>
          <p>Nenhuma imagem disponível</p>
        </div>
      </div>
      
      <!-- Upload de nova imagem -->
      <div class="mt-3">
        <h6><i class="fas fa-upload"></i> Alterar Imagem</h6>
        <file-upload
          v-model="imagensEditando"
          :toBucket="false"
          :setDefault="true"
          :enableTitle="false"
          :max-files="1"
        />
      </div>
    </b-modal>

    <b-table
      :items="produtosFiltrados"
      :fields="camposComEmpresas"
      striped
      stacked="sm"
      responsive="sm"
      :busy="loading"
      small
      style="font-size: 11px"
    >
      <!-- <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template> -->

      <template v-for="campo in camposComEmpresas" v-slot:[`cell(${campo.key})`]="row">
        <div :key="campo.key">
          <div v-if="campo.key.includes('empresa')">
            <b-form-checkbox
              switch
              :unchecked-value="0"
              :checked="
                row.item.status && campo.index >=0 && row.item.status[campo.index]
                  ? row.item.status[campo.index].status
                  : 0
              "
              :value="1"
              @change="onChangeStatus(row.item, campo)"
              :disabled="loadingInterno"
            />
          </div>
          <div v-else>
            {{ row.item[campo.key] }}
          </div>
        </div>
      </template>

      <template #cell(actions)="row">
        <div v-if="canManage">
          <b-btn variant="warning" size="sm" class="mr-3" @click="editar(row.item)">
            <i class="fas fa-edit" /> Editar
          </b-btn>
          <b-btn variant="secondary" size="sm" class="mr-3" @click="duplicar(row.item)">
            <i class="fas fa-copy" /> Duplicar
          </b-btn>
          <b-btn variant="danger" size="sm" @click="excluir(row.item)">
            <i class="fas fa-trash" /> Excluir
          </b-btn>
        </div>
      </template>


      <template #cell(img)="row">
        <div 
          class="product-avatar" 
          v-if="row.item.imagens && row.item.imagens.length > 0"
          @click="abrirModalImagem(row.item)"
        >
          <img 
            :src="row.item.imagens[0].fileThumbUrl || row.item.imagens[0].fileURL" 
            :alt="row.item.nome"
            class="avatar-img"
            @error="onImageError"
          />
        </div>
        <div 
          class="product-avatar no-image" 
          v-else
          @click="abrirModalImagem(row.item)"
        >
          <i class="fas fa-image"></i>
        </div>
      </template>

      <template #cell(preco_venda)="row">
        <b-input
          v-model="row.item.preco_venda"
          @blur="updateProduct(row.item)"
          style="margin: 0 auto; max-width: 100px; text-align: center; background: white"
          v-money="moneyMask"
        />
      </template>
      <template #cell(nome)="row">
        <b-input v-model="row.item.nome" @blur="updateProduct(row.item)" />
      </template>
    </b-table>
    <b-pagination
      v-model="pagination.page"
      :total-rows="pagination.total"
      :per-page="pagination.limit"
    />
  </div>
</template>

<script>
import ProdutoLib from "@/libs/ProdutoLib.js";
import CardapioTemasMixin from "./CardapioTemasMixin.js";
import FileUpload from "../common/FileUpload.vue";

export default {
  mixins: [CardapioTemasMixin],
  components: {
    FileUpload,
  },
  props: {
    produtos: { Array, required: true },
    filtro: String,
    loading: Boolean,
    grupoSelecionado: { type: Number, required: false },
    canManage: {
      type: Boolean,
      default: true,
    },
    pagination: Object,
  },
  data() {
    return {
      empresas: [],
      loadingInterno: false,
      paginacao: {
        registros_por_pagina: 30,
        pagina_atual: 1,
      },
      // Dados do modal de imagem
      produtoSelecionado: null,
      imagensEditando: [],
      // Dados da empresa para impressão
      nomeEmpresa: "",
      telefoneEmpresa: "",
      enderecoEmpresa: "",
      horarioFuncionamento: "",
      whatsappEmpresa: ""
    };
  },
  methods: {
    async updateProduct(product) {
      let produto = JSON.parse(JSON.stringify(product));
      produto.valor_extra = this.formatValorReal(produto.valor_extra);
      produto.preco_venda = this.formatValorReal(produto.preco_venda);
      produto.preco_custo = this.formatValorReal(produto.preco_custo);
      await ProdutoLib.update(produto.cod_produto, produto);
      this.showToast("success", "Produto salvo com sucesso!");
      this.$store.dispatch("auth/atualizarProduto", produto);
    },
    duplicar(produto) {
      this.$emit("duplicar", produto);
    },
    editar(produto) {
      this.$emit("editar", produto);
    },
    onRowSelected(produto) {
      if (produto) {
        this.$emit("editar", produto[0]);
      }
      this.$refs.produtosTable.clearSelected();
    },
    async carregaEmpesas() {
      this.$forceUpdate();
      await this.$nextTick();
      this.empresas = [...this.$store.state.empresas.empresas];
      this.empresas.push(this.$store.state.empresas);
      this.empresas = this.empresas.sort((a, b) =>
        a.cod_empresa > b.cod_empresa ? 1 : a.cod_empresa < b.cod_empresa ? -1 : 0
      );
      if (this.user && this.user.tipo && this.user.tipo == "Gerente") {
        if (
          this.user.configuracoes &&
          this.user.configuracoes.empresas &&
          this.user.configuracoes.empresas.length > 0
        ) {
          this.empresas = this.empresas.filter((x) => {
            return (
              this.user.configuracoes.empresas.filter((y) => y == x.cod_empresa).length >
              0
            );
          });
        } else {
          this.empresas = this.empresas.filter(
            (x) => x.cod_empresa == this.user.cod_empresa
          );
        }
      }
    },
    async onChangeStatus(produto, campo) {
      produto = JSON.parse(JSON.stringify(produto))
      console.log("produto changed", produto, 'campo', campo)
      if (!produto.status[campo.index]) {
        produto.status.push({
          cod_empresa: campo.cod_empresa,
          empresa: campo.empresa,
          status: 1,
          _rowStatus: "added",
        });
      } else {
        produto.status[campo.index].status = produto.status[campo.index].status ? 0 : 1;

        if (!produto.status[campo.index]._rowStatus) {
          // this.$set(produto.status[campo.index], "_rowStatus", "updated");
        }
      }
 
      await this.updateProduct(produto)
      // await this.salvar(produto);
    },
    async salvar(produto) {
      try {
        this.loadingInterno = true;
        await this.updateProduct(produto)

        this.$emit("salvar", produto);
        // await this.$store.dispatch("auth/atualizarCardapio");
      } catch (error) {
        this.showToast("error", `Ops, alguma coisa deu errado :/\n${error.message}`);
      } finally {
        this.loadingInterno = false;
      }
    },
    async excluir(produto) {
      this.$forceUpdate();
      await this.$nextTick();
      const { cod_produto, cod_grupo } = produto;
      if (cod_produto) {
        this.$swal
          .fire({
            title: "Você tem creteza que deseja excluir este produto?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim. Excluir!",
            cancelButtonText: "Não.",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              const result = await ProdutoLib.del(cod_produto);
              // console.log( result)
              if (result.data && result.status == 200) {
                this.$store.dispatch("auth/apagarProduto", {
                  cod_produto,
                  cod_grupo,
                });
                const i = this.produtos.findIndex((p) => p.cod_produto == cod_produto);
                if (i != -1) this.produtos.splice(i, 1);
                this.$swal.fire({
                  title: "Produto excluído com sucesso!",
                  icon: "success",
                  toast: true,
                  timer: 1500,
                  position: "top-end",
                  showConfirmButton: false,
                });
              } else {
                this.$swal.fire({
                  title: "Erro ao excluir produto!",
                  icon: "error",
                  toast: true,
                  timer: 1500,
                  position: "top-end",
                  showConfirmButton: false,
                });
              }
            }
          });
      }
    },
    
    // Métodos específicos para cardápio
    carregarDadosEmpresa() {
      // Carregar dados da empresa do store
      const empresa = this.$store.state.empresas || {};
      this.nomeEmpresa = empresa.nome || "Restaurante";
      this.telefoneEmpresa = empresa.telefone || "";
      this.enderecoEmpresa = empresa.endereco || "";
      this.horarioFuncionamento = empresa.horario_funcionamento || "";
      this.whatsappEmpresa = empresa.whatsapp || "";
    },
    
    async executarImpressao() {
      // Criar uma nova janela para impressão
      const cardapioWindow = window.open('', '_blank', 'width=800,height=600');
      
      // Obter dados organizados para impressão
      const cardapioHTML = await this.gerarHTMLCardapio();
      
      cardapioWindow.document.write(cardapioHTML);
      cardapioWindow.document.close();
      
      // Aguardar carregamento e imprimir
      cardapioWindow.onload = () => {
        cardapioWindow.print();
        // Não fechar automaticamente para permitir salvar como PDF
        // cardapioWindow.close();
      };
    },
    
    async organizarProdutosPorGrupo(todosProdutos = null) {
      try {
        // Usar todos os produtos fornecidos ou os produtos locais
        const produtosParaOrganizar = todosProdutos || this.produtos || [];
        
        // Buscar grupos para ter as informações completas
        const ProdutoGrupoLib = await import("@/libs/ProdutoGrupoLib.js");
        const grupos = await ProdutoGrupoLib.default.get();
        
        console.log('Produtos a serem organizados:', produtosParaOrganizar.length);
        console.log('Grupos disponíveis:', grupos.length);
        
        const gruposMap = new Map();
        
        // Agrupar todos os produtos, incluindo aqueles sem grupo
        produtosParaOrganizar.forEach(produto => {
          // Usar cod_grupo ou criar um grupo padrão
          const codGrupo = produto.cod_grupo || 'sem_grupo';
          const grupo = grupos.find(g => g.cod_grupo === produto.cod_grupo);
          const nomeGrupo = grupo ? grupo.Grupo : (produto.cod_grupo ? 'Categoria Não Encontrada' : 'Sem Categoria');
          
          if (!gruposMap.has(codGrupo)) {
            gruposMap.set(codGrupo, {
              nome: nomeGrupo,
              ordem: grupo ? grupo.ordem || 999 : 999,
              produtos: []
            });
          }
          gruposMap.get(codGrupo).produtos.push(produto);
        });
        
        // Converter para array e ordenar
        const gruposArray = Array.from(gruposMap.values());
        gruposArray.forEach(grupo => {
          grupo.produtos.sort((a, b) => a.nome.localeCompare(b.nome));
        });
        
        const result = gruposArray.sort((a, b) => {
          // Primeiro por ordem, depois por nome
          if (a.ordem !== b.ordem) {
            return a.ordem - b.ordem;
          }
          return a.nome.localeCompare(b.nome);
        });
        
        console.log('Grupos organizados:', result.length);
        console.log('Total de produtos nos grupos:', result.reduce((total, grupo) => total + grupo.produtos.length, 0));
        
        return result;
        
      } catch (error) {
        console.error('Erro ao organizar produtos por grupo:', error);
        // Fallback simples se der erro
        return this.organizarProdutosPorGrupoSimples(todosProdutos);
      }
    },
    
    organizarProdutosPorGrupoSimples(todosProdutos = null) {
      console.log('Usando fallback simples para organizar produtos');
      
      // Usar todos os produtos fornecidos ou os produtos locais
      const produtosParaOrganizar = todosProdutos || this.produtos || [];
      const gruposMap = new Map();
      
      // Agrupar todos os produtos, incluindo aqueles sem grupo
      produtosParaOrganizar.forEach(produto => {
        // Usar cod_grupo ou criar um grupo padrão
        const codGrupo = produto.cod_grupo || 'sem_grupo';
        const nomeGrupo = produto.grupo_nome || produto.Grupo || 'Sem Categoria';
        
        if (!gruposMap.has(codGrupo)) {
          gruposMap.set(codGrupo, {
            nome: nomeGrupo,
            produtos: []
          });
        }
        gruposMap.get(codGrupo).produtos.push(produto);
      });
      
      // Converter para array e ordenar
      const gruposArray = Array.from(gruposMap.values());
      gruposArray.forEach(grupo => {
        grupo.produtos.sort((a, b) => a.nome.localeCompare(b.nome));
      });
      
      return gruposArray.sort((a, b) => a.nome.localeCompare(b.nome));
    },
    
    formatarPreco(valor) {
      if (!valor) return "0,00";
      return parseFloat(valor).toFixed(2).replace(".", ",");
    },
    
    onImageError(event) {
      // Se houver erro ao carregar a imagem, esconde o elemento
      event.target.style.display = 'none';
      event.target.parentElement.classList.add('no-image');
      const icon = document.createElement('i');
      icon.className = 'fas fa-image';
      event.target.parentElement.appendChild(icon);
    },
    
    // Métodos para o modal de imagem
    abrirModalImagem(produto) {
      this.produtoSelecionado = JSON.parse(JSON.stringify(produto));
      this.imagensEditando = produto.imagens ? [...produto.imagens] : [];
      this.$bvModal.show('modal-imagem-produto');
    },
    
    async salvarImagem() {
      try {
        if (!this.produtoSelecionado) return;
        
        // Atualizar as imagens do produto
        this.produtoSelecionado.imagens = [...this.imagensEditando];
        
        // Salvar no backend
        await this.updateProduct(this.produtoSelecionado);
        
        // Atualizar o produto na lista local
        const index = this.produtos.findIndex(p => p.cod_produto === this.produtoSelecionado.cod_produto);
        if (index !== -1) {
          this.$set(this.produtos, index, { ...this.produtoSelecionado });
          this.$forceUpdate();
        }
        
        this.showToast("success", "Imagem atualizada com sucesso!");
        
        // Fechar o modal
        this.$bvModal.hide('modal-imagem-produto');
        
        // Limpar dados
        this.produtoSelecionado = null;
        this.imagensEditando = [];
        this.$store.dispatch("auth/atualizarProduto");
        
      } catch (error) {
        this.showToast("error", `Erro ao salvar imagem: ${error.message}`);
      }
    },
    
    cancelarEdicaoImagem() {
      this.produtoSelecionado = null;
      this.imagensEditando = [];
    },
  },
  async mounted() {
    this.carregaEmpesas();
  },
  computed: {
    produtosFiltrados() {
      return this.produtos
        .map((prod) => ({
          ...prod,
          preco_venda: this.formatFloatToReal(prod.preco_venda),
        }))
        .filter((prod) => {
          if (this.grupoSelecionado) {
            return prod.cod_grupo == this.grupoSelecionado;
          }
          return true;
        });
    },
    camposComEmpresas() {
      return [
        { key: "img", label: "", sortable: true },
        { key: "cod_produto", label: "Código", sortable: true },
        { key: "nome", label: "Nome", class: "text-left" },
        { key: "preco_venda", label: "Preço", class: "text-center" },
        ...this.empresas
          .filter((x) => this.user.nivel < 2 || x.cod_empresa == this.user.cod_empresa)
          .map((e, i) => {
            return {
              key: `empresa_${e.cod_empresa}`,
              label: e.nome,
              cod_empresa: e.cod_empresa,
              empresa: e.nome,
              index: i,
              class: "text-center empresasTable",
            };
          }),
        { key: "actions", label: "" },
      ];
    },
  },
};
</script>

<style lang="scss">
.empresasTable {
  white-space: nowrap;
  font-size: 0.7rem;
}

// Estilos para o avatar do produto
.product-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e9ecef;
  background-color: #f8f9fa;
  margin: 0 auto;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #007bff;
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
  }
  
  .avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  &.no-image {
    color: #6c757d;
    font-size: 16px;
    
    &:hover {
      color: #007bff;
      background-color: #e3f2fd;
    }
    
    i {
      opacity: 0.6;
    }
  }
}

// Estilos para o modal de imagem
.current-image-container {
  max-width: 400px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  
  .current-image {
    width: 100%;
    height: auto;
    max-height: 300px;
    object-fit: contain;
  }
}

.no-image-placeholder {
  padding: 40px;
  color: #6c757d;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  background-color: #f8f9fa;
  
  i {
    font-size: 48px;
    margin-bottom: 10px;
    opacity: 0.5;
  }
  
  p {
    margin: 0;
    font-style: italic;
  }
}

// Estilos para o modal de seleção de tema
.tema-preview {
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 250px;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  
  &.tema-selecionado {
    border-color: #28a745;
    background-color: rgba(40, 167, 69, 0.1);
  }
  
  .preview-header {
    text-align: center;
    margin-bottom: 15px;
    
    h3 {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 5px;
    }
    
    p {
      font-size: 14px;
      color: #666;
      margin: 0;
    }
  }
  
  .preview-content {
    .preview-categoria {
      h4 {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        padding-bottom: 5px;
        border-bottom: 1px solid #eee;
      }
      
      .preview-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;
        font-size: 14px;
        border-bottom: 1px solid #f5f5f5;
        
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}

.tema-limpo {
  background: white;
  border: 2px solid #ddd;
  
  .preview-content {
    font-family: Arial, sans-serif;
    color: #333;
    
    .preview-categoria h4 {
      color: #333;
      text-transform: uppercase;
    }
  }
}

.tema-estilizado {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: white;
  border: 2px solid #32cd32;
  
  .preview-header {
    h3, p {
      color: white;
    }
  }
  
  .preview-content {
    font-family: 'Poppins', sans-serif;
    
    .preview-categoria {
      h4 {
        color: #32cd32;
        text-transform: uppercase;
        border-bottom-color: #32cd32;
      }
      
      .preview-item {
        border-bottom-color: rgba(255, 255, 255, 0.1);
        
        .preco-destaque {
          color: #32cd32;
          font-weight: bold;
          background: rgba(50, 205, 50, 0.1);
          padding: 2px 8px;
          border-radius: 12px;
          border: 1px solid #32cd32;
        }
      }
    }
  }
}

.tema-estilizado-claro {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  color: #333;
  border: 2px solid #28a745;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.2);
  
  .preview-header {
    h3, p {
      color: #333;
    }
    
    h3 {
      color: #28a745;
      font-weight: 600;
    }
  }
  
  .preview-content {
    font-family: 'Poppins', sans-serif;
    
    .preview-categoria {
      h4 {
        color: #28a745;
        text-transform: uppercase;
        border-bottom-color: #28a745;
        font-weight: 600;
      }
      
      .preview-item {
        border-bottom-color: rgba(40, 167, 69, 0.1);
        
        .preco-destaque-claro {
          color: #28a745;
          font-weight: bold;
          background: rgba(40, 167, 69, 0.1);
          padding: 3px 10px;
          border-radius: 15px;
          border: 1px solid #28a745;
        }
      }
    }
  }
}

.tema-estilizado-branco {
  background: #ffffff;
  color: #1a202c;
  border: 2px solid #4299e1;
  box-shadow: 0 4px 12px rgba(66, 153, 225, 0.15);
  
  .preview-header {
    h3, p {
      color: #1a202c;
    }
    
    h3 {
      color: #4299e1;
      font-weight: 600;
    }
  }
  
  .preview-content {
    font-family: 'Inter', sans-serif;
    
    .preview-categoria {
      h4 {
        color: #2d3748;
        text-transform: uppercase;
        border-bottom-color: #e2e8f0;
        font-weight: 600;
        position: relative;
        padding-left: 8px;
      }
      
      h4::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        background: #4299e1;
        border-radius: 2px;
      }
      
      .preview-item {
        border-bottom-color: #e2e8f0;
        background: #ffffff;
        
        .preco-destaque-branco {
          color: #4299e1;
          font-weight: 600;
          background: transparent;
          padding: 0;
          border-radius: 0;
          border: none;
        }
      }
    }
  }
}
</style>
